import { useHookstate } from "@hookstate/core";
import { currentInstallation } from "./ScrbTools";

const operators = {
    '>': function (a, b, _c) { return a > b },
    '<': function (a, b, _c) { return a < b },
    '>=': function (a, b, _c) { return a >= b },
    '<=': function (a, b, _c) { return a <= b },
    '===': function (a, b, _c) { return b.includes(a) },
    '!==': function (a, b, _c) { return !b.includes(a) },
    'is': function (a, b, _c) { return a === b },
    'between': function (a, b, c) { return a > b && a < c }
};

const ConditionalComponent = (props) => {
    const installation = useHookstate(currentInstallation);
    const rules = props.rules;
    const state = props.objState;
    const stateValue = state.get();
    const conditionOperator = props.conditionOperator ? props.conditionOperator : "&&";

    const ids = props.id;
    let render = true;
    ids.forEach((id, iterator) => {
        if (render || conditionOperator === "||") {
            const currentRule = rules[id]?.rule;
            const values = currentRule?.values;
            const valueMax = currentRule?.valueMax;
            const element = currentRule?.element;
            const operator = currentRule?.operator ?? "===";
            let finalElement = stateValue[element];
            if (props.object)
                finalElement = stateValue[props.object][element];
            if (
                ((conditionOperator !== "||" && render) || (conditionOperator === "||"))
                && !(conditionOperator === "||" && render && iterator > 0)
            )
                render = values && finalElement !== undefined && operators[operator](finalElement, values, valueMax);
        }
    })

    if (render === false && props.targetField) {
        props.targetField.forEach(e => {
            installation["chaudiere"][e.field].set(e.clearanceValue);
        });
    }

    return (
        render && (props.component)
    );
}

export default ConditionalComponent;